/**
 * Channel types for Employment Group chat channels
 */
import { z } from "zod";
import { MessageType } from "./chat.js";
// ============================================
// Channel Response
// ============================================
export const ChannelResponseSchema = z.object({
    id: z.uuid(), // This is the Conversation ID
    groupId: z.uuid(), // EmploymentGroup ID
    groupName: z.string(),
    memberCount: z.number().int().nonnegative(),
    isGroup: z.literal(true),
    name: z.string().optional(), // Conversation name (usually same as group name)
    companyId: z.uuid(),
    lastMessageTime: z.iso.datetime().nullable().optional(),
    lastMessagePreview: z.string().optional(),
    lastMessageSenderId: z.uuid().optional(),
    unreadCount: z.number().int().nonnegative(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
// ============================================
// Channel List
// ============================================
export const ChannelListResponseSchema = z.object({
    channels: z.array(ChannelResponseSchema),
    nextCursor: z.string().optional(),
    hasMore: z.boolean(),
});
// ============================================
// Query / Input Schemas
// ============================================
export const GetChannelsQuerySchema = z.object({
    limit: z.coerce.number().min(1).max(50).default(20),
    cursor: z.uuid().optional(),
});
export const GetChannelMessagesQuerySchema = z.object({
    limit: z.coerce.number().min(1).max(50).default(20),
    cursor: z.uuid().optional(),
});
export const SendChannelMessageInputSchema = z.object({
    content: z.string().trim().min(1).max(10000),
    type: z.nativeEnum(MessageType).default(MessageType.TEXT),
    attachments: z.array(z.object({
        url: z.string().url(),
        filename: z.string(),
        mimeType: z.string(),
        size: z.number().positive(),
    })).optional(),
    replyToId: z.uuid().optional(),
});
